import React from "react";
import { Translate } from "react-localize-redux";
import './RequiredLabel.scss';

const RequiredLabel = () => {
  return (
    <span className="RequiredLabel__container">
      *<Translate id="RequiredText" />
    </span>
  );
};

export default RequiredLabel;



// WEBPACK FOOTER //
// ./src/components/RequiredLabel/RequiredLabel.jsx